import { Button } from '@mui/material'
import React from 'react'
import cx from 'classnames'

type ButtonProps = React.ComponentProps<typeof Button>

export type ContainedButtonProps = Omit<ButtonProps, 'variant' | 'ref' | 'innerRef' | 'itemRef'> & {
  position?: 'relative' | 'fixed'
  showSpinner?: boolean
}

const ContainedButtonView = React.forwardRef<HTMLButtonElement, ContainedButtonProps>(
  (props, ref) => {
    const { color = 'primary', children, className, disabled, showSpinner, ...rest } = props

    return (
      <Button
        className={cx(
          'rounded-3xl h-12 min-w-[159px]',
          color === 'primary' &&
            'bg-primary-main hover:bg-primary-main/50 text-primary-contrastText',
          color === 'secondary' && 'border-[1px] border-solid border-primary-main',
          disabled && 'bg-secondary-main',
          className
        )}
        ref={ref}
        type={props.type}
        {...rest}>
        {showSpinner && (
          <svg className="animate-spin h-8 w-8 text-white" fill="none" viewBox="0 0 24 24">
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        )}
        {!showSpinner && children}
      </Button>
    )
  }
)

ContainedButtonView.displayName = 'ContainedButtonView'

export default ContainedButtonView
